import React from "react";

export default function FooterSmall(props: { absolute: any; }) {
  return (
    <>
      <footer
        className={
          (props.absolute
            ? "absolute w-full bottom-0 bg-slate-800"
            : "relative") + " pb-6"
        }
      >
        <div className="container mx-auto px-4">
          <hr className="mb-6 border-b-1 border-slate-600" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4">
              <div className="text-sm text-slate-500 font-semibold py-1 text-center md:text-left">
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  href="https://mecanica.mx"
                  className="text-white hover:text-slate-300 text-sm font-semibold py-1"
                >
                  Mecanica MX
                </a>
              </div>
            </div>
            <div className="w-full md:w-8/12 px-4">
              <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                <li>
                  <a
                    href="https://mecanica.mx"
                    className="text-white hover:text-slate-300 text-sm font-semibold block py-1 px-3"
                    target='_blank'
                  >
                    Mecanica MX
                  </a>
                </li>
                <li>
                  <a
                    href="https://mecanica.mx"
                    className="text-white hover:text-slate-300 text-sm font-semibold block py-1 px-3"
                    target='_blank'
                  >
                    Acerca de nosotros
                  </a>
                </li>
                <li>
                  <a
                    href="https://blog.mecanica.mx"
                    className="text-white hover:text-slate-300 text-sm font-semibold block py-1 px-3"
                    target='_blank'
                  >
                    Blog
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
